import { StringDevUIField } from "./StringDevUIField";

export class StringDevFieldColor extends StringDevUIField<string> {
  private colorInput: HTMLInputElement | null = null;
  private hexLabel: HTMLInputElement | null = null;

  build(): HTMLElement {
    const row = this.createRow();
    row.appendChild(this.createLabel());
    row.appendChild(this.createControl());
    this.root = row;
    return row;
  }

  setValue(value: string): void {
    this.value = value;
    if (this.colorInput) this.colorInput.value = value;
    if (this.hexLabel) this.hexLabel.value = value;
  }

  override setDisabled(disabled: boolean): void {
    super.setDisabled(disabled);
    if (this.colorInput) this.colorInput.disabled = disabled;
    if (this.hexLabel) this.hexLabel.disabled = disabled;
  }

  private createControl(): HTMLDivElement {
    const shell = document.createElement("div");
    shell.setAttribute("data-stdg-field-input", "");

    const colorInput = document.createElement("input");
    colorInput.type = "color";
    colorInput.value = this.value;
    colorInput.setAttribute("data-stdg-input", "");
    colorInput.setAttribute("data-stdg-input-color", "");

    const hexLabel = document.createElement("input");
    hexLabel.type = "text";
    hexLabel.inputMode = "text";
    hexLabel.value = this.value;
    hexLabel.setAttribute("data-stdg-input", "");

    colorInput.addEventListener("input", () => {
      hexLabel.value = colorInput.value;
      this.emit(colorInput.value);
    });

    hexLabel.addEventListener("change", () => {
      const val = hexLabel.value.trim();
      colorInput.value = val;
      this.emit(val);
    });

    this.colorInput = colorInput;
    this.hexLabel = hexLabel;

    shell.appendChild(colorInput);
    shell.appendChild(hexLabel);
    return shell;
  }
}
